(() => {
  const PARAMS_TO_KEEP = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'gbraid',
    'wbraid'
  ];

  const enhanceLinks = (root) => {
    const current = new URLSearchParams(window.location.search);
    const kept = new URLSearchParams();

    PARAMS_TO_KEEP.forEach((name) => {
      const value = current.get(name);
      if (value) kept.set(name, value);
    });

    if ([...kept.keys()].length === 0) return;

    root.querySelectorAll('[data-mos-reaction-cta]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);
        kept.forEach((value, key) => {
          if (!url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        link.href = url.toString();
      } catch (error) {
        // Keep the original link when the browser cannot parse it.
      }
    });
  };

  const getActiveCurrency = (root) => (
    root.dataset.mosReactionCurrency ||
    window.Shopify?.currency?.active ||
    'EUR'
  );

  const getCurrencyRate = () => {
    const raw = window.Shopify?.currency?.rate;
    const rate = Number.parseFloat(raw);
    return Number.isFinite(rate) && rate > 0 ? rate : null;
  };

  const getLocale = () => {
    const country = window.Shopify?.country;
    if (country) return `en-${country}`;
    return navigator.language || 'en-US';
  };

  const formatRewardAmounts = (root) => {
    root.querySelectorAll('[data-mos-reaction-reward-amount]').forEach((amount) => {
      const baseEur = Number.parseFloat(amount.dataset.baseEur);
      if (!Number.isFinite(baseEur)) return;

      const currency = getActiveCurrency(root);
      const rate = currency === 'EUR' ? 1 : getCurrencyRate();
      if (!rate) return;
      const converted = Math.round(baseEur * rate);

      try {
        amount.textContent = new Intl.NumberFormat(getLocale(), {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(converted);
      } catch (error) {
        amount.textContent = amount.dataset.fallback || `€${Math.round(baseEur)}`;
      }
    });
  };

  const setupSticky = () => {
    const sticky = document.querySelector('[data-mos-reaction-sticky]');
    const heroCta = document.querySelector('[data-mos-reaction-hero-cta]');
    const final = document.querySelector('[data-mos-reaction-final]');

    if (!sticky || !heroCta || !final || !('IntersectionObserver' in window)) return;
    if (sticky.dataset.mosReactionStickyReady === 'true') return;
    sticky.dataset.mosReactionStickyReady = 'true';

    let heroVisible = true;
    let finalVisible = false;

    const sync = () => {
      sticky.classList.toggle('is-visible', !heroVisible && !finalVisible);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === heroCta) heroVisible = entry.isIntersecting;
        if (entry.target === final) finalVisible = entry.isIntersecting;
      });
      sync();
    }, { threshold: 0.01 });

    observer.observe(heroCta);
    observer.observe(final);
    sync();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-mos-reaction-root]').forEach((root) => {
      if (root.dataset.mosReactionReady === 'true') return;
      root.dataset.mosReactionReady = 'true';
      enhanceLinks(root);
      formatRewardAmounts(root);
    });
    setupSticky();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
